import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompanyComponent } from './company/company.component';
import { CompanyConsentComponent } from './company/pages/company-consent/company-consent.component';
import { LoginType } from './constants/login-type.enum';
import { InvestorComponent } from './investor/investor.component';
import { InvestorConsentComponent } from './investor/pages/investor-consent/investor-consent.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout/login-layout.component';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { LoginComponent } from './login/login.component';
import { ScheduleCompanyComponent } from './schedule-company/schedule-company.component';
import { ScheduleInvestorComponent } from './schedule-investor/schedule-investor.component';
import { AuthGuardGuard } from './shared/services/auth-guard.guard';
import { UnauthorizeComponent } from './unauthorize/unauthorize.component';

const routes: Routes = [
  { path: 'register-company/:eventAlias', loadChildren: () => import('./register-company/register-company.module').then(m => m.RegisterCompanyModule) },
  { path: 'register-investor/:eventAlias', loadChildren: () => import('./register-investor/register-investor.module').then(m => m.RegisterInvestorModule) },
  { path: 'register-seminar-investor/:eventAlias', loadChildren: () => import('./register-seminar-investor/register-seminar-investor.module').then(m => m.RegisterSeminarInvestorModule) },
  { path: 'external/company/:token', component: LoginLayoutComponent, 
    children: [
      { path: '', component: ScheduleCompanyComponent, 
        data: { 
        loginType: LoginType.company,
        showHeader: true,
        showUserInfo: false
       }
      }
    ]
  },
    { path: 'external/investor/:token', component: LoginLayoutComponent, 
    children: [
      { path: '', component: ScheduleInvestorComponent, 
        data: { 
        loginType: LoginType.investor,
        showHeader: true,
        showUserInfo: false
       }
      }
    ]
  },
  { path: 'login/:eventAlias/company', component: LoginLayoutComponent, 
    children: [
      { path: '', component: LoginComponent, 
        data: { 
        loginType: LoginType.company,
        showHeader: false
       }
      }
    ]
  },
  { path: 'login/:eventAlias/investor', component: LoginLayoutComponent, 
    children: [
      { path: '', component: LoginComponent, 
        data: { 
          loginType: LoginType.investor,
          showHeader: false
         }
      }
    ]
  },
  { path: 'login/admin', component: LoginAdminComponent, data: { loginType: LoginType.admin} },
  {
    path: 'regis/:eventAlias', component: LoginLayoutComponent, canActivate: [AuthGuardGuard],
    children: [
      { path: 'company/:registerCompanyId/consent', component: CompanyConsentComponent, data: { showHeader: false } },
      { path: 'company/:registerCompanyId', component: CompanyComponent, data: { showHeader: true } },
      { path: 'investor/:registerInvestorId/consent', component: InvestorConsentComponent, data: { showHeader: false } },
      { path: 'investor/:registerInvestorId', component: InvestorComponent, data: { showHeader: true },
        // children: [
        //   { path: '', redirectTo: 'meeting-request', pathMatch: 'full' },
        //   { path: 'meeting-request', component: MeetingRequestComponent },
        //   { path: 'available-time', component: AvailableTimeComponent },
        //   { path: 'investor-info', component: InvestorInfoComponent },
        //   { path: 'hotel', component: HotelComponent },
        // ]
      },
    ]
  },
  { path: 'checkin/:eventAlias', loadChildren: () => import('./check-in/check-in.module').then(m => m.CheckInModule) },
  { path: 'session-timeout', component: UnauthorizeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
